module.exports = __webpack_public_path__ + "img/DimensionsMissing.cb262720.svg";